import React, {useEffect, useState} from 'react';
import AutoConversionToggle from "../AutoConversionToggle";
import NumberInput from "../BankTransfers/NumberInput";

function PaymentInformationForm({payload, setPayload, handleNext}) {

    const [data, setData] = useState({
        AutoConversionToUSD: false,
        AutoConversionToLBP: false,
        LimitPerTransactionUSD: "",
        LimitPerTransactionLBP: ""
    });

    const [errors, setErrors] = useState({
        LimitPerTransactionUSD: "",
        LimitPerTransactionLBP: ""
    });

    const isVisited = Object.keys(payload.MerchantEnrollmenPaymentInfo).length !== 0

    useEffect(() => {
        if(isVisited){
            setData(payload.MerchantEnrollmenPaymentInfo);
        }
    }, []);

    const handle_LbpToUsd_change = () => {
        if (!data.AutoConversionToLBP) {
            setData({...data, AutoConversionToUSD: !data.AutoConversionToUSD});
        }
    };

    const handle_UsdToLbp_change = () => {
        if (!data.AutoConversionToUSD) {
            setData({...data, AutoConversionToLBP: !data.AutoConversionToLBP});
        }
    };

    const validate = () => {
        let tmp = {};
        tmp.LimitPerTransactionUSD = data.LimitPerTransactionUSD && Number(data.LimitPerTransactionUSD) > 0? "" : "This field is required.";
        tmp.LimitPerTransactionLBP = data.LimitPerTransactionLBP && Number(data.LimitPerTransactionLBP) > 0? "" : "This field is required.";

        setErrors(tmp);
        return Object.values(tmp).every(x => x === "");
    }

    const handleContinue = () => {
        if (validate()) {
            setPayload({...payload, MerchantEnrollmenPaymentInfo: data});
            handleNext();
        }
    }


    return (
        <>
            <div className="form-container payment-information">
                <div className="form-title">
                    PAYMENT INFORMATION
                </div>

                <AutoConversionToggle
                    isChecked={data.AutoConversionToUSD}
                    handle_toggleChange={handle_LbpToUsd_change}
                    convertText="Convert LBP to USD as payments settle"
                    disabled={data.AutoConversionToLBP}
                />

                <AutoConversionToggle
                    isChecked={data.AutoConversionToLBP}
                    handle_toggleChange={handle_UsdToLbp_change}
                    convertText="Convert USD to LBP as payments settle"
                    disabled={data.AutoConversionToUSD}
                />

                <div className="form-group">
                    <div className="form-label">Limit Per Transaction (USD)</div>
                    <div className="form-input">
                        <NumberInput payload={data} setPayload={setData} currency={1} objKey="LimitPerTransactionUSD" defaultValuee={data.LimitPerTransactionUSD}/>
                    </div>
                    {errors.LimitPerTransactionUSD && <div className="error">{errors.LimitPerTransactionUSD}</div>}
                </div>

                <div className="form-group">
                    <div className="form-label">Limit Per Transaction (LBP)</div>
                    <div className="form-input">
                        <NumberInput payload={data} setPayload={setData} currency={2} objKey="LimitPerTransactionLBP" defaultValuee={data.LimitPerTransactionLBP}/>
                    </div>
                    {errors.LimitPerTransactionLBP && <div className="error">{errors.LimitPerTransactionLBP}</div>}
                </div>
            </div>
            <button onClick={handleContinue} className="continue-btn">Continue</button>
        </>
    );
}

export default PaymentInformationForm;